import React, {Component} from "react";
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import axios from "axios/index";
import {userActions} from "../../authentication/_actions";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";
import {AxiosHeader} from "../../functions/GlobalFunctions";

class DropDownDma extends Component {

    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);

        this.state = {
            loading: false,
            dma: []
        };
    }


    handleSelect(value){
        this.props.handlerFromParent(value);

    }

    componentDidMount() {

        if (AxiosHeader.getConfig() !== null) {

            const url = process.env.REACT_APP_API_URL + "/Channels/dma";

            axios
                .get(url, AxiosHeader.getConfig())
                .then(res => {
                    const dma = res.data;
                    const loading = false;
                    //console.log(mode);
                    this.setState({dma, loading});
                })
                .catch(error => {
                    this.setState({loading: false});
                    console.log(error);
                });
        }else{
            this.props.dispatch(userActions.logoutUnauthorized());
        }

    }

    render() {
        return (
            <div>
                <Select
                    placeholder="DMA Select"
                    name="dmaSelect"
                    autoFocus={false}
                    multi={true}
                    isSearchable={true}
                    value={this.props.dmaSelected}
                    options={this.state.dma}
                    onChange={value => this.handleSelect(value)}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedDropDownDma = connect(mapStateToProps)(DropDownDma);
const connectedDropDownDmaTrans = withNamespaces('common')(connectedDropDownDma);
export {connectedDropDownDmaTrans as DropDownDma};

